import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const independientesModule = {
	state: {
		independientes : ''
	},
	getters: {  
        getIndependientes : state => state.independientes
	},
	actions: {
        requestIndependientes({commit}){
            return new Promise((resolve, reject) => {
				axios.get("/api/Alumno/dameProgramasIndepentientes/1").then( result => {
					commit('setIndependientes', result.data.datos.independientes); 
					resolve(true);
				}).catch(error => {
					reject(false);
				});  
			});	
        },
	},
	mutations: {
        setIndependientes(state, independientes){
            state.independientes = independientes;
        }
	}
}

export default independientesModule;


// WEBPACK FOOTER //
// ./src/store/programasIndependientesModule.js